import { z } from "zod";

export const shippingLabelReportBodySchema = z.object({
	customerId: z.string(),
	carrierName: z.string(),
	poNumber: z.number(),
	quoteId: z.number(),
	numberOfLabels: z.number(),
	labelsPerPage: z.number(),
	labelSize: z.string(),
	rotate: z.boolean(),
	showSequenceNumber: z.boolean(),
	additionalDetails: z.string(),
	pickupName: z.string(),
	pickupAddress1: z.string(),
	pickupAddress2: z.string().nullable(),
	pickupCityState: z.string(),
	pickupZip: z.string(),
	deliveryName: z.string(),
	deliveryAddress1: z.string(),
	deliveryAddress2: z.string().nullable(),
	deliveryCityState: z.string(),
	deliveryZip: z.string(),
	retrieveDocuments: z.literal(true),
});

export type ShippingLabelReportBody = z.infer<
	typeof shippingLabelReportBodySchema
>;

export const shippingLabelReportResponseSchema = z.object({
	proNumberReady: z.boolean(),
	carrierProNumberSupported: z.boolean(),
	pdf: z.string(), // base64 encoded string
});

export type ShippingLabelReportResponse = z.infer<
	typeof shippingLabelReportResponseSchema
>;
